import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { membershipApi, UserFamilyMember } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const errorBadRequest: membershipApi.ErrorBadRequest = {
  status: 400,
  title: 'Errore Bad Request',
  type: 'urn:badreq',
  rc: 101,
}
export const putFamilyMember = http.put<object, UserFamilyMember, object>(
  apiBaseUrl + '/familyMembers/:familyMemberId',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  async ({ request }) => {
    const body = await request.json()
    if (body.firstName?.startsWith('BADREQUEST')) return HttpResponse.json(errorBadRequest, { status: 400 })
    else return HttpResponse.text(undefined, { status: 204 })
  },
)
